const appName = process.env.VUE_APP_NAME;
const appUrl = process.env.VUE_APP_URL;
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
const hasEms = process.env.VUE_APP_EMS_INTEGRATION;

export { appName, appUrl, apiBaseUrl, hasEms };
